import React from "react";
import { Briefcase } from "@phosphor-icons/react";
import { makeT } from "@/lib/i18n";

/**
 * Read-only seniority badge. The interview level is decided by the AI from
 * the candidate's documents — the user cannot override it, by design, so
 * the practice session mirrors a real interview.
 *
 * Props:
 *   seniority: { level: "entry"|"mid"|"managerial"|"executive", rationale?: string }
 *   lang: "en" | "pt-br" | "both"
 *   showHint: boolean — if true, renders the "no manual override" one-liner below
 */
export function SeniorityBadge({ seniority, lang = "en", showHint = false, testId = "seniority-badge" }) {
  const t = makeT(lang);
  const level = seniority?.level;
  if (!level) return null;
  const label = t(`sen.${level}`);
  return (
    <div data-testid={testId}>
      <div className="inline-flex items-center gap-2 rounded-full border border-[color:var(--brand)]/30 bg-[color:var(--brand)]/5 px-4 py-1.5 text-sm">
        <Briefcase
          weight="duotone"
          size={16}
          className="text-[color:var(--brand)]"
        />
        <span className="text-[10px] uppercase tracking-widest text-[color:var(--text-secondary)]">
          {t("sen.eyebrow")}
        </span>
        <span
          className="font-semibold tracking-tight text-[color:var(--brand)]"
          data-testid={`${testId}-level`}
        >
          {label}
        </span>
      </div>
      {showHint && (
        <p className="mt-2 text-xs text-[color:var(--text-secondary)] max-w-xl leading-relaxed">
          {t("sen.hintDocs")}
        </p>
      )}
    </div>
  );
}
